import { useState } from 'react'
import { useAsync } from 'react-use'

import { useAccountContext } from 'components/contexts/AccountContext'
import {
  DEFAULT_PARTNER_ACCOUNT_SETTINGS,
  DEFAULT_PARTNER_PRODUCT_SETTINGS,
  mapPartnerFeatureFlags,
  PartnerAccountSettings,
} from 'types/PartnerAccountSettings'
import { fetchPartnerAccountSettings } from 'utils/fetchPartnerAccountSettings'
import useHasPartnerAccess from './useHasPartnerAccess'

type AccountKey = string
const SettingsMap = new Map<AccountKey, PartnerAccountSettings>()

export const usePartnerAccountSettings = (): PartnerAccountSettings => {
  const { partnerAccountKey, accountKey: selectedAccountKey } = useAccountContext()
  const [partnerAccountSettings, setPartnerAccountSettings] = useState(DEFAULT_PARTNER_ACCOUNT_SETTINGS)
  const { isPartnerUser } = useHasPartnerAccess()

  useAsync(async () => {
    const accountKey = partnerAccountKey || selectedAccountKey || ''
    let partnerAccountSettings: PartnerAccountSettings = SettingsMap.get(accountKey) || DEFAULT_PARTNER_ACCOUNT_SETTINGS

    if (isPartnerUser && accountKey && !SettingsMap.has(accountKey)) {
      const response = await fetchPartnerAccountSettings(accountKey)
      partnerAccountSettings = {
        featureFlags: mapPartnerFeatureFlags(response.featureFlags),
        productSettings: { ...DEFAULT_PARTNER_PRODUCT_SETTINGS, ...response.productSettings },
      }

      SettingsMap.set(accountKey, partnerAccountSettings)
    }

    setPartnerAccountSettings(partnerAccountSettings)
  }, [partnerAccountKey, selectedAccountKey, isPartnerUser])

  return partnerAccountSettings
}

export default usePartnerAccountSettings
